import { render, staticRenderFns } from "./CustomerMatch.vue?vue&type=template&id=0e703316&scoped=true&"
import script from "./CustomerMatch.vue?vue&type=script&lang=js&"
export * from "./CustomerMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e703316",
  null
  
)

export default component.exports